module.exports = __webpack_public_path__ + "static/media/281f890c-8412-4ee3-84ed-8b5d062d2ab8.5a5c4ac8.woff2";